import validationHelper from './validationHelper';

export interface EmailFormValidator {
    email?: string;
}

export const INVALID_EMAIL_MSG = 'Please enter a valid e-mail address.';

export default (formValues: EmailFormValidator) => {
    const errors: EmailFormValidator = {};
    if (!validationHelper.isValidEmail(formValues.email || '')) {
        errors.email = INVALID_EMAIL_MSG;
    }
    return errors;
};
